import { Box, LinearProgress, Typography } from '@mui/material'

export type ProgressBarProps = {
  value: number
  max?: number
  label?: string
  showPercentage?: boolean
  showFraction?: boolean
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error'
  size?: 'small' | 'medium'
  variant?: 'rounded' | 'square'
}

export default function ProgressBar({
  value,
  max = 100,
  label,
  showPercentage = true,
  showFraction = false,
  color = 'primary',
  size = 'medium',
  variant = 'rounded',
}: ProgressBarProps) {
  let percentage = max > 0 ? Math.round((value / max) * 100) : 0
  let height = size === 'small' ? 6 : 8

  return (
    <Box sx={{ width: '100%' }}>
      {label && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
          {(showPercentage || showFraction) && (
            <Typography variant="body2" color="text.secondary">
              {showFraction && `${value}/${max}`}
              {showFraction && showPercentage && ' • '}
              {showPercentage && `${percentage}%`}
            </Typography>
          )}
        </Box>
      )}

      <LinearProgress
        variant="determinate"
        value={percentage}
        color={color}
        sx={{
          height,
          borderRadius: variant === 'rounded' ? height / 2 : 0,
          backgroundColor: 'action.hover',
        }}
      />
    </Box>
  )
}
